export default `npm i react-dashboard-pro -S
`;
